import styled from 'styled-components';
import { color, displaySoft, label, bp, ease } from '../../styles/tokens';

export const Layout = styled.div`
  display: grid;
  gap: clamp(36px, 6vw, 64px);

  ${bp.md} {
    grid-template-columns: 1fr 1.1fr;
    align-items: center;
  }
`;

export const Details = styled.div`
  .eyebrow {
    ${label};
    color: ${color.rose};
    margin-bottom: 16px;
  }

  h2 {
    ${displaySoft};
    font-style: italic;
    font-size: clamp(40px, 6vw, 68px);
    color: ${color.white};
    /* Leading kept above 1 so the italic descenders clear "studio" below. */
    line-height: 1.02;

    span {
      display: block;
      ${label};
      font-style: normal;
      letter-spacing: 0.5em;
      color: ${color.rose};
      margin-top: clamp(8px, 1.6vw, 18px);
    }
  }

  dl {
    margin-top: 32px;
    padding-top: 28px;
    border-top: 1px solid ${color.lineDark};
  }

  dt {
    ${label};
    font-size: 10px;
    color: ${color.rose};
    margin-bottom: 6px;
  }

  dd {
    font-size: 15px;
    font-weight: 300;
    line-height: 1.6;
    color: rgba(240, 220, 222, 0.82);
    max-width: 34ch;
  }
`;

export const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 32px;
`;

export const Map = styled.div`
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid ${color.lineDark};

  iframe {
    width: 100%;
    height: clamp(280px, 46vw, 440px);
    border: 0;
    /* Nudges Google's default map palette toward the page's plum-grey. */
    filter: grayscale(0.4) contrast(0.94);
    transition: filter 0.5s ${ease};
  }

  &:hover iframe {
    filter: none;
  }
`;

export const Colophon = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  margin-top: clamp(48px, 7vw, 80px);
  padding-top: 26px;
  border-top: 1px solid ${color.lineDark};
  ${label};
  font-size: 10px;
  color: rgba(240, 220, 222, 0.45);
`;
